<div class="contents">
  <div class="index-box">{{ templateItem.order }}</div>
  <span
    [ngClass]="{ 'disabled text-navy-400': !template?.permissions?.can_edit || template.template_items.length < 2 }"
    cdkDragHandle
    class="icon-draggable text-blue-700 text-[20px] cursor-pointer"
  ></span>
  @if (isManagerTemplate(templateItem)) {
    <app-floating-input
      [name]="'account_code' + templateItem.id"
      [maxLength]="20"
      (ngModelChange)="fieldChanged('account_code', $event)"
      [ngModel]="templateItem.account_code"
      [verticalSpacing]="false"
      [disabled]="!template?.permissions?.can_edit"
    ></app-floating-input>
  } @else {
    <app-floating-input
      [name]="'division' + templateItem.id"
      [maxLength]="10"
      (ngModelChange)="fieldChanged('division', $event)"
      [ngModel]="templateItem.division"
      [verticalSpacing]="false"
      [disabled]="!template?.permissions?.can_edit"
      data-cy="division-input-parent"
    ></app-floating-input>
    <app-floating-input
      inputClass="bg-navy-100 opacity-100"
      [disabled]="true"
      [name]="'cost_type' + templateItem.id"
      [maxLength]="20"
      (ngModelChange)="fieldChanged('cost_type', $event)"
      [ngModel]="templateItem.cost_type"
      [verticalSpacing]="false"
      data-cy="cost-type-input-parent"
    ></app-floating-input>
  }
  <app-floating-input
    [name]="'description' + templateItem.id"
    [maxLength]="40"
    (ngModelChange)="fieldChanged('description', $event)"
    [ngModel]="templateItem.description"
    [verticalSpacing]="false"
    [disabled]="!template?.permissions?.can_edit"
    data-cy="description-input-parent"
  ></app-floating-input>

  <span
    (click)="minusClicked()"
    [ngClass]="{
      'disabled hidden': !template.permissions.can_edit,
      disabled: template.template_items.length < 2
    }"
    class="icon-minus-box add-remove-btn"
  ></span>
  <span
    data-cy="add-subitem-button"
    (click)="plusClicked()"
    [ngClass]="{ 'disabled hidden': !template.permissions.can_edit }"
    class="icon-plus-box add-remove-btn"
  ></span>
</div>
